
export const getSetting = (key: string) => {
    //@ts-ignore
    const settings = wvnderlab_chat_bot;
    const keys = key.split('.');

    let value: any = settings;

    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            return undefined;
        }
    }

    return value;
};
